import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { IGeneralData } from '../../models/general.model';

export enum ActionTypes {
  CHANGE_HEADER = '[User] Load Request',
  CHANGE_FOOTER = '[User] Load Failure',
  ADD_STATE = 'User Add state',
  CHANGE_LOADING_STATUS = 'Loading status',
  CHANGE_SORT_BY_OPTION = '[User] Change SortBy Oprion',
  CHANGE_LAST_REQUEST_ASKED = '[User] Change Last Request Asked',
  CHANGE_HOTEL_INFO = '[User] Change Hotel Info',
  CHANGE_BOOKING_ACTION = '[User] Change user Action',
  SET_USER_INFO = '[App] Set users info',
  SET_UNREAD_MESSAGES = '[App] Set unread messages',
  SET_ACTIVE_OFFERS = '[App] Set Active Offers',
  TOGGLE_LOGIN_MODAL = '[App] Toggle Login Modal',
  SET_BOOK_NOW_BUTTON_CLICKED = '[User] Book Now Button clicked',
  SEND_REQUEST_ENABLED = '[User] Send Request Enabled'
}

export class HeaderChangeAction implements Action {
  readonly type = ActionTypes.CHANGE_HEADER;
  constructor (public id: number,
  public changes: Partial<IGeneralData>) {}
}

export class FooterChangeAction implements Action {
  readonly type = ActionTypes.CHANGE_FOOTER;
  constructor(public payload: Update<IGeneralData>) {}
}

export class ChangeLoadingStatusAction implements Action {
  readonly type = ActionTypes.CHANGE_LOADING_STATUS;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class ChangeSortByOptionAction implements Action {
  readonly type = ActionTypes.CHANGE_SORT_BY_OPTION;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class ChangeLasteRequestAsked implements Action {
  readonly type = ActionTypes.CHANGE_LAST_REQUEST_ASKED;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class ChangeHotelInfo implements Action {
  readonly type = ActionTypes.CHANGE_HOTEL_INFO;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class ChangeBookingAction implements Action {
  readonly type = ActionTypes.CHANGE_BOOKING_ACTION;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class SetUserInfo implements Action {
  readonly type = ActionTypes.SET_USER_INFO;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class SetUreadMessage implements Action {
  readonly type = ActionTypes.SET_UNREAD_MESSAGES;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class SetActiveOffers implements Action {
  readonly type = ActionTypes.SET_ACTIVE_OFFERS;
  constructor(public activeOfferes: number,
    public changes: Partial<IGeneralData>) {}
}

export class ToggleLoginModal implements Action {
  readonly type = ActionTypes.TOGGLE_LOGIN_MODAL;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class BookNowButtonClicked implements Action {
  readonly type = ActionTypes.SET_BOOK_NOW_BUTTON_CLICKED;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}

export class SendRequest implements Action {
  readonly type = ActionTypes.SEND_REQUEST_ENABLED;
  constructor(public id: number,
    public changes: Partial<IGeneralData>) {}
}


export class AddStateAction implements Action {
  readonly type = ActionTypes.ADD_STATE;
  constructor(public payload: {data: IGeneralData}) {}
}

export type Actions = HeaderChangeAction |
                      FooterChangeAction |
                      AddStateAction |
                      ChangeLoadingStatusAction |
                      ChangeSortByOptionAction |
                      ChangeLasteRequestAsked |
                      ChangeHotelInfo |
                      ChangeBookingAction |
                      SetUserInfo |
                      SetUreadMessage |
                      SetActiveOffers |
                      ToggleLoginModal |
                      BookNowButtonClicked |
                      SendRequest;
